import React from 'react';
import { Bar } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import { useAuthStore } from '../../store/store';
import { getMoodStressBarData, getSatisfactionTirednessBarData } from '../../data/chartData';
import { moodStressBarOption, satisfactionTirednessBarOption } from '../../data/chartOptions';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { useQuery } from '@tanstack/react-query';
import { getCheckInDataForToday } from '../../api/dashboard';
import ClipLoader from 'react-spinners/ClipLoader';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
);

const BarGraphsToday = () => {
    const uid = useAuthStore(store => store.user?.uid);

    const checkInDataQuery = useQuery({
        queryKey: ['checkInForToday', uid],
        queryFn: () => getCheckInDataForToday(uid),
        retry: false,
        enabled: !(uid === null || uid === undefined),
    });

    if (checkInDataQuery.isLoading) {
        return (
            <div className='loading col-span-2'>
                <ClipLoader
                    loading={checkInDataQuery.isLoading}
                    size={100}
                    aria-label='Loading Spinner'
                />
            </div>
        );
    }

    if (checkInDataQuery.isError || checkInDataQuery.data === null) {
        return (
            <div className='col-span-2 mt-3 text-center'>
                <p>You have not checked in yet. Please check in to view your mood and stress level summary.</p>
            </div>
        );
    }

    return (
        <>
            <div className='min-h-[300px]'>
                <Bar
                    options={moodStressBarOption}
                    data={getMoodStressBarData(checkInDataQuery.data?.mood, checkInDataQuery.data?.stress)}
                    className='mb-5'
                />
            </div>
            <div className='min-h-[300px]'>
                <Bar
                    options={satisfactionTirednessBarOption}
                    data={getSatisfactionTirednessBarData(checkInDataQuery.data?.satisfaction, checkInDataQuery.data?.tiredness)}
                />
            </div>
        </>
    );
};

export default BarGraphsToday;
